import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import { useUser } from '@ztechapps/common.hook'
import { Button } from 'react-bootstrap'

export type LogoutButtonProps = { text?: string; after?: () => void }
export const LogoutButton = ({ text = 'Sign out', after }: LogoutButtonProps) => {
  const { logout } = useUser()

  const _logout = (e) => {
    e.preventDefault()
    logout()
    after?.()
  }

  return (
    <Button variant="primary" onClick={_logout}>
      <Icon name="sign-out" /> {text}
    </Button>
  )
}
